import { defineStore } from "pinia";
import axios from "axios";
import { useLoadingStore } from "@/stores/loadingStore";

export const useFeatureStore = defineStore("featureStore", {
  state: () => ({
    featureHeadline: "",
    featureDescription: "",
    featureSecondHeadline: "",
    featureButtonText: "",
    featureButtonLink: "",
    features: [],
    isLoading: false,
    error: null,
  }),

  actions: {
    async fetchFeatures() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/Feature/GetFeatures");
        this.features = response.data.Payload.Features;
        this.featureHeadline = response.data.Payload.Settings.features_headline;
        this.featureDescription =
          response.data.Payload.Settings.features_description;
        this.featureSecondHeadline =
          response.data.Payload.Settings.features_second_headline;
        this.featureButtonText =
          response.data.Payload.Settings.features_button_text;
        this.featureButtonLink =
          response.data.Payload.Settings.features_button_link;
      } catch (error) {
        this.error = "Özellikler alınırken bir hata oluştu";
      } finally {
        this.isLoading = false;
        loadingStore.finishLoading();
      }
    },
  },
});
